import Button from '@carvana/ds-button';
import React from 'react';
import styles from './simple-confirm.module.css';
import { PaymentDetailsCard } from '../pay-at-order/payment-details-card';

interface SimpleConfirmProps {
  isSubmitting: boolean;
  onSubmit: () => void;
  hasPaymentSummary: boolean;
  priceDetails?: React.ReactNode;
}

export const SimpleConfirm = ({
  isSubmitting,
  onSubmit,
  hasPaymentSummary,
  priceDetails
}: SimpleConfirmProps) => {
  return (
    <div className={styles.container}>
      {hasPaymentSummary && (priceDetails ?? <PaymentDetailsCard />)}

      <div className={styles.buttonContainer}>
        <Button
          variant="primary"
          size="md"
          disabled={isSubmitting}
          isLoading={isSubmitting}
          onClick={onSubmit}
          data-analytics-id="pp_complete_purchase_place_order"
        >
          Place order
        </Button>
      </div>
    </div>
  );
};
